// XNGAGE CONFIDENTIAL
// __________________________

//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { titleTypographyStyles } from "@conklin/App/Components/Common/TitleTypography";
import { createLinkIconStyles, getSystemColor, xScreen } from "@conklin/XDL/Utilities";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import { css } from "styled-components";

titleTypographyStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 12px;
        ${xScreen("lte", "sm")} {
            gap: 10px;
            justify-content: space-between;
        }
    `,
};

titleTypographyStyles.title = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
        ${xScreen("lte", "sm")} {
            margin-right: 0;
        }
    `,
};

createLinkIconStyles;
titleTypographyStyles.link = {
    ...createLinkIconStyles(
        ChevronRight,
        "default",
        "right",
        false,
        {
            color: getSystemColor("common.ui4"),
            hoverStyle: {
                color: getSystemColor("common.ui8"),
            },
            css: css`
                margin-left: auto;
                ${xScreen("lte", "sm")} {
                    margin-left: 0;
                }
                &:focus {
                    outline: none;
                }
                align-items: center;
            `,
        },
        {
            size: 16,
            weight: "bold",
            lineHeight: "22px",
            css: css`
                letter-spacing: 0;
            `,
        },
        {
            size: 16,
        },
    ),
};
